<template>
	<div v-if="isUserAllowedInLevel5or6">
		<div v-if="isUserAllowedInLevel5or6">
			<RentalCarPricingRepairShop></RentalCarPricingRepairShop>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import Authentication from '@/mixins/Authentication';
import RentalCarPricingRepairShop from '@/components/rentalcars/pages/RentalCarPricingRepairShop';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'RentalCarPricing',
	components: { Forbidden, RentalCarPricingRepairShop },
	mixins: [Authentication],
};
</script>

<style scoped>
.form-group {
	margin: 0;
}
</style>
